import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  const privacyContent = <div className="space-y-4" data-id="element-13">
      <p data-id="element-14">Última actualización: febrero 2024</p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-15">
        1. Información que recopilamos
      </h3>
      <p data-id="element-16">
        Recopilamos la información que nos proporcionas directamente al crear
        una cuenta, suscribirte a nuestro boletín o comunicarte con nosotros.
        Esto puede incluir tu nombre, dirección de correo electrónico y
        cualquier otra información que decidas proporcionar.
      </p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-17">
        2. Cómo usamos tu información
      </h3>
      <p data-id="element-18">
        Usamos la información recopilada para operar, mantener y mejorar
        nuestros servicios, comunicarnos contigo y personalizar tu experiencia.
        No vendemos tus datos personales a terceros.
      </p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-19">
        3. Seguridad de los datos
      </h3>
      <p data-id="element-20">
        Implementamos medidas técnicas y organizativas apropiadas para proteger
        la seguridad de tu información personal. Sin embargo, ningún método de
        transmisión por Internet o almacenamiento electrónico es 100% seguro.
      </p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-21">4. Cookies</h3>
      <p data-id="element-22">
        Usamos cookies y tecnologías de seguimiento similares para rastrear la
        actividad en nuestro servicio y almacenar cierta información. Puedes
        configurar tu navegador para rechazar todas las cookies o para indicar
        cuándo se envía una cookie.
      </p>
    </div>;
  const termsContent = <div className="space-y-4" data-id="element-23">
      <p data-id="element-24">Última actualización: febrero 2024</p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-25">
        1. Aceptación de los términos
      </h3>
      <p data-id="element-26">
        Al acceder o utilizar nuestro servicio, aceptas estar sujeto a estos
        Términos de Servicio. Si no estás de acuerdo con alguna parte de los
        términos, no podrás acceder al servicio.
      </p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-27">
        2. Licencia de uso
      </h3>
      <p data-id="element-28">
        Se concede permiso para descargar temporalmente una copia de los
        materiales (información o software) en nuestro sitio web para
        visualización personal y no comercial únicamente. Esta es una concesión
        de licencia, no una transferencia de título.
      </p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-29">
        3. Descargo de responsabilidad
      </h3>
      <p data-id="element-30">
        Los materiales en nuestro sitio web se proporcionan "tal cual". No
        ofrecemos garantías, expresas o implícitas, y por la presente
        renunciamos a todas las demás garantías, incluidas las garantías
        implícitas de comerciabilidad, idoneidad para un propósito particular o
        no infracción de propiedad intelectual.
      </p>

      <h3 className="text-lg font-semibold text-[#2A6B6B] mt-6" data-id="element-31">
        4. Limitaciones
      </h3>
      <p data-id="element-32">
        En ningún caso nosotros o nuestros proveedores seremos responsables de
        daños (incluidos, entre otros, daños por pérdida de datos o beneficios,
        o por interrupción del negocio) que surjan del uso o la imposibilidad de
        usar los materiales en nuestro sitio web.
      </p>
    </div>;
  return <footer className="w-full py-8 px-4 border-t border-[#E8DDD0] mt-12 bg-white/50" data-id="element-33">
      <div className="max-w-3xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-34">
        <div className="text-[#5C544E] text-sm text-center md:text-left" data-id="element-35">
          <p data-id="element-36">
            © {new Date().getFullYear()} Estabilidad y Equilibrio en Casa.
            Todos los derechos reservados.
          </p>
          <p className="mt-1" data-id="element-37">
            Este producto no sustituye el consejo médico profesional.
          </p>
        </div>

        <div className="flex items-center gap-6" data-id="element-38">
          <button onClick={() => setActiveModal('privacy')} className="text-sm text-[#5C544E] hover:text-[#2A6B6B] transition-colors" data-id="element-39">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-sm text-[#5C544E] hover:text-[#2A6B6B] transition-colors" data-id="element-40">
            Términos de Servicio
          </button>
        </div>
      </div>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" content={privacyContent} data-id="element-41" />

      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos de Servicio" content={termsContent} data-id="element-42" />
    </footer>;
}